exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[v-cloak][data-v-e8fbbb28]{display:none}.fade-enter-active[data-v-e8fbbb28],.fade-leave-active[data-v-e8fbbb28]{transition:all .5s ease}.fade-enter[data-v-e8fbbb28],.fade-leave-active[data-v-e8fbbb28]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e8fbbb28","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main.vue
// module id = 85
// module chunks = 0